import React, { useState } from "react";
import "./welcome.css";
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as Logo } from "../icons/logo.svg";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

const Welcome = ({ onDone }) => {
    const [leaving, setLeaving] = useState(false);
    const navigate = useNavigate();

    const FIRST_RUN_KEY = "foxer_seen_welcome_v1";


    usePageTitle("Foxer - Welcome");


    return (
        <AnimatePresence
            onExitComplete={() =>
                setTimeout(() => navigate("/", { replace: true, state: { fromWelcome: true } }), 300)
            }
        >
            {!leaving && (
                <motion.div className="welcome-container"
                    exit={{ opacity: 0 }}
                >
                    <Logo className="welcome-logo" />

                    <motion.p
                        className="welcome-title"
                        initial={{ opacity: 0, y: -10, filter: "blur(2px)" }}
                        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        transition={{ duration: 0.4, delay: 1.57 }}
                    >
                        Welcome to Foxer
                    </motion.p>

                    <motion.p
                        className="welcome-subtitle"
                        initial={{ opacity: 0, y: -10, filter: "blur(2px)" }}
                        animate={{ opacity: 0.6, y: 0, filter: "blur(0px)" }}
                        transition={{ duration: 0.4, delay: 1.77 }}
                    >
                        A calmer way to organize your tasks, stay focused, and actually get things done.
                    </motion.p>

                    <motion.button
                        className="welcome-button"
                        initial={{ opacity: 0, y: -10, filter: "blur(2px)" }}
                        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        transition={{ duration: 0.4, delay: 1.97 }}
                        onClick={() => {
                            localStorage.setItem(FIRST_RUN_KEY, "1");
                            onDone?.();
                            setLeaving(true);
                        }}
                    >
                        Get started
                    </motion.button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Welcome;
